import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlBalancete = '/service/balanceteDespesaRestService/'

class TransfFinAdmService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracoes.length > 0 ? filtro.administracoes.map(e => e.value).join() : this.state.adms,
            exercicio: filtro.exercicio.value,
            mes: filtro.mes && filtro.mes.value < 10 ? '0' + filtro.mes.value : filtro.mes.value,
        }
        return this.conex.post(urlBalancete + 'recuperarTransferenciasFinanceiras/', JSON.stringify(data))
    }
}

export default TransfFinAdmService
